/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Template_Regex_HelpInputs */



/**
* | output |
* | --- |
* | "Use standard JavaScript regex syntax. Patterns are case-insensitive by default." |
*
* @param {Compliance_Template_Regex_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_template_regex_help = /** @type {((inputs?: Compliance_Template_Regex_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Template_Regex_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwenden Sie Standard-JavaScript-Regex-Syntax. Muster sind standardmäßig nicht case-sensitiv.")
	return /** @type {LocalizedString} */ ("Use standard JavaScript regex syntax. Patterns are case-insensitive by default.")
});